import React from 'react';
import ProjectBox from './ProjectBox';
import NewsletterImage from '../images/NewsletterImage.png';
import RogfreeImage from '../images/RogfreeImage.png';
import TindogImage from '../images/TindogImage.png';

const Projects = () => {
  return (
    <div>
      <h1 className='projectHeading'>My <b>Projects</b></h1>
      <div className='project'>
        <ProjectBox projectPhoto={TindogImage} projectName="Sippi" />
        <ProjectBox projectPhoto={RogfreeImage} projectName="NamamiDigital" />
        <ProjectBox projectPhoto={NewsletterImage} projectName="ForceTools" />
        <ProjectBox projectPhoto={TindogImage} projectName="Portfolio" />
        <ProjectBox projectPhoto={RogfreeImage} projectName="Sleepinplush" />
        <ProjectBox projectPhoto={NewsletterImage} projectName="Shivpsy" />
      </div>

    </div>
  )
}

export default Projects